export const PLAIN_TEXT_PATTERN = /^[^<>\u0000-\u001f\u007f]*$/;
export const IDENTITY_MAX_LENGTH = 100;
export const WORKSPACE_TITLE_MAX_LENGTH = 100;
